import { ICourseCartInput, PRODUCT_SLUG } from "@types";
import { FESTIVAL_TYPE } from "enums/festival-type";
import { ApiProductThumbnailImages } from "types/api/product-image";

export { FESTIVAL_TYPE };

export interface StepData {
  from: number;
  to: number;
  discount: number;
  is_percent: boolean;
}

export interface FestivalCategory extends ApiProductThumbnailImages {
  id: number;
  slug: string;
  english_name: string;
  name: string;
}
export interface IFestivalResponse {
  message: string;
  data: {
    festival: {
      id: number;
      badge: null;
      description: string | null;
      discount_text: string;
      footer_description: string | null;
      has_banner: boolean;
      has_landing: boolean;
      image_large: string;
      image_large_png: string;
      image_medium: string;
      image_medium_png: string;
      image_small: string;
      image_small_png: string;
      image_x_large: string;
      image_x_large_png: string;
      image_x_small: string;
      image_x_small_png: string;
      image_xx_large: string;
      image_xx_large_png: string;
      is_active: boolean;
      is_all_products_included: boolean;
      products: [];
      slug: string;
      special_text: string;
      time_period: {
        start_at: number;
        expire_at: number;
      };
      title: string;
      type: FESTIVAL_TYPE;
    };
    categories?: FestivalCategory[];
    steps?: StepData[];
  };
}

export interface SwiperFestivalProduct {
  title: string;
  all_title: string;
  type: string;
  parameter: [];
  slug: PRODUCT_SLUG;
  products: ICourseCartInput[];
}

export interface IFestivalProductInput {
  status: boolean;
  message: string;
  data: {
    products: ICourseCartInput[];
    pagination: {
      page: string;
      limit: string;
      total: number;
      load_more: boolean;
    };
  };
}

export interface IFestivalProductParams {
  count?: number;
  page?: number;
  sort: FESTIVAL_SORT;
  category_id?: string;
}
export enum FESTIVAL_SORT {
  MOST_POPULAR = "most_popular",
  NEWEST = "newest",
}
export const USER_PRODUCT_SLUGS = [
  PRODUCT_SLUG.USER_RECOMMENDED_PRODUCTS,
  PRODUCT_SLUG.USER_RECENT_VIEW_PRODUCT,
] as const;

export const STEPPED_PRODUCT_SLUGS = new Set<string>([
  FESTIVAL_TYPE.STEPPED_AMOUNT,
  FESTIVAL_TYPE.STEPPED_COUNT,
]);

export interface FestivalProps {
  festivalData?: IFestivalResponse;
}
export interface FestivalPropsError {
  error: {
    error?: {
      code: number;
      details: string;
      message: string;
    };
    __abp: boolean;
    unAuthorizedRequest: boolean;
  };
}

export interface IFestivalParamsOutput {
  page?: number;
  category?: string;
  sort?: FESTIVAL_SORT;
}
